import React from 'react';
import styled from '@emotion/styled';
import { ColorsTheme, Sizes, themeColor } from '../../components/Theme';
import SendIcon from '@material-ui/icons/Send';
import HistoryIcon from '@material-ui/icons/History';
import { TextareaAutosize } from '@material-ui/core';
import { media } from '../media';
import { Time } from './Questions.style';
import { ScrollbarStyle } from '../../components/BasePage';
import { AttachFileOutlined, NotificationsOutlined } from '@material-ui/icons';
import download_file from "../Pages/common_icons/download_file.svg";
import warning_icon from "../Pages/common_icons/warning_deactivate_red.svg";
import rac_logo_icon from "../Pages/common_icons/rac_only_logo_black.svg";

export const AttachmentFileIcon = styled.img<{ size?: "small" | "medium" }>`
  width: ${props => props.size === "small" ? 14 : 20}px;
  height: ${props => props.size === "small" ? 21 : 30}px;
`;
AttachmentFileIcon.defaultProps = { src: download_file, alt: "" };

export const Wrapper = styled.div`
    padding: 40px 19px;
    width: 750px;
    margin: auto;
    position: relative;
    box-sizing: border-box;
    background-color: ${themeColor(c => c.alabaster)};

    @media ${media.l} {
        padding: 40px 5px;
        width: 100%;
    }

    & .socket-openning {
      position: absolute;
      top: 4px;
      right: 4px;
      font-size: 16px;

      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 4px;
    }
`;

export const UserInput = styled.div`
    position: absolute;
    left: 0;
    bottom: 0;
    padding: 15px 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 15px;
    background-color: ${themeColor(c => c.whiteDefault)};
`;

export const NotificationsIcon = styled(NotificationsOutlined)`
    cursor: pointer;
`;
NotificationsIcon.defaultProps = { role: "button", color: "action" }

export const AttachmentIcon = styled(AttachFileOutlined)`
    cursor: pointer;
`;
AttachmentIcon.defaultProps = { role: "button", color: "action" }


export const InputMessageWrapper = styled(TextareaAutosize)`
    padding: 8px 12px;
    flex: 1 0 auto;
    height: 35px;
    outline: none;
    resize: none;

    background-color: ${themeColor(c => c.alabaster)};
    border-radius: ${Sizes.geometry.borderRadius.button}px;
    border: none;
    font-family: "Ubuntu";
    font-size: 18px;
    font-weight: 300;
`;



export const Warning = styled.img`
    margin: 0 6px;
`;

export const WarningIcon = () => <Warning key="warning-tail" src={warning_icon} />;

export const AdminOfficeIcon = styled.span`
  background: ${ColorsTheme.black};
  height: 1em;
  aspect-ratio: 1;
  display: inline-block;
  mask: url(${rac_logo_icon});
  mask-size: cover;
  flex-shrink: 0;
`;



export const UserName = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  color: ${ColorsTheme.darkRedDefault};

  & ${AdminOfficeIcon} {
    font-size: 0.75em;
    margin-right: 4px;
  }
`;



export const Message = styled.div<{ isMy?: boolean }>`
    margin: ${props => props.isMy ? "30px 0 30px auto" : "30px 0"};
    padding: 6px 10px;
    width: fit-content;
    border-radius: 10px 10px ${props => props.isMy ? 0 : 10}px ${props => props.isMy ? 10 : 0}px;
    background-color: ${props => themeColor(c => props.isMy ? c.fairPink : c.whiteDefault)};
    border-left: 3px solid transparent;
    word-break: break-word;

    white-space: pre-line;
`;

export const AdminMessage = styled(Message)<{ isWarning?: boolean }>`
  border-left: ${props => props.isWarning ? `3px solid ${themeColor(c => c.burntUmber)}` : "none"};

  & ${UserName} {
    & ${Warning} {
      transform: translate(0, 1px);
    }
  }
`;


export const MessageHeadLine = styled.div<{ side: "left" | "right" }>`
  display: flex;
  flex-flow: ${props => props.side === "right" ? "row-reverse" : "row"};
  align-items: baseline;
  justify-content: flex-start;
  margin-bottom: 0.25rem;
  user-select: none;
  
  & > ${Time} {
    margin: 0;
    white-space: nowrap;
  }

  & > .occupy {
    min-width: 3rem;
    flex: 1 0 auto;
  }
`;

export const Text = styled.p`
    margin: 4px 0 0 0;
    font-size: 20px;
    font-weight: 400;
    color: ${themeColor(c => c.ebony)};
    white-space: pre-line;
`;

export const TextLink = styled.a`
    margin: 4px 0 0 0;
    font-size: 20px;
    font-weight: 400;
    color: ${themeColor(c => c.ebony)};
    display: flex;
    align-items: center;
    cursor: pointer;

    & > img:first-child {
      margin-right: 0.5rem;
    }
`;

export const Messages = styled.div`
    padding: 0 5px;
    height: calc(100vh - 80px - 200px - 37px - 64.5px - 118.5px);
    overflow-y: auto;
    margin-bottom: 30px;

    @media ${media.s} {
        /* - <paddings from wrapper> - user input - header - slack */
        height: calc(100vh - 80px - 64.5px - 61px - 10px);
    }
    
    ${ScrollbarStyle}
`;

export const SendIconWrapper = styled(SendIcon)`
    cursor: pointer;
    fill: ${themeColor(c => c.darkRedDefault)};
`;

export const HistoryIconWrapper = styled(HistoryIcon)`
    cursor: pointer;
    fill: ${themeColor(c => c.graySolid)};
`;

export const Event = styled.p<{ isWarning?: boolean }>`
    margin: 20px auto;
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    color: ${props => themeColor(c => props.isWarning ? c.darkRedDefault : c.blackDefault)};
    white-space: pre-line;
`;

